<template>
  <f7-page class="rowBackgroundHomepage" :class="customPageClass">
    <!-- <div v-else style="height:20px;"></div> -->
    <b-container fluid :class="{customContainer: !noReduce}">
      <!-- <b-row v-if="!isSmartphoneOS && !noReturn" class="w-100">
        <b-col md="12" class="p-0">
          <back-button id="back-button" :returnUrl="returnUrl"></back-button>
        </b-col>
      </b-row> -->
      <b-row>
        <b-col :md="colWidth" :offset-md="(12 - colWidth)/2" class="p-0">
          <main :id="mainContentId" class="panel21 panel-default" role="main">
            <!-- Header avec bordure et ombre subtile -->
            <header class="panel-heading mb-0 mt-0 bg-white border border-bottom shadow-sm mx-n4 px-4">
              <b-row class="align-items-center gx-4 mt-3 pb-3">
                <!-- Colonne titre -->
                <b-col cols="12" md="6" lg="7" xl="8" class="pe-3">
                  <!-- Version Mobile -->
                  <div class="d-block d-md-none text-center">
                    <h1 class="panel-title mb-0">
                      <slot name="titleContent">
                        <span class="fs-24px">{{ title }}</span>
                      </slot>
                    </h1>
                    <div v-if="mandatoryIndication" class="italicMandatoryIndication">
                      {{ $t('common.asterisk_obligation_label')}}
                    </div>
                  </div>
                  <!-- Version Desktop -->
                  <div class="d-none d-md-block text-start">
                    <h1 class="panel-title mb-0">
                      <slot name="titleContent">
                        <span class="fs-24px">{{ title }}</span>
                      </slot>
                    </h1>
                    <div v-if="mandatoryIndication" class="italicMandatoryIndication">
                      {{ $t('common.asterisk_obligation_label')}}
                    </div>
                  </div>
                </b-col>
                <!-- Colonne actions - responsive comme les tabs -->
                <b-col v-if="$slots.primaryActions" cols="12" md="6" lg="5" xl="4" class="mt-3 mt-md-0">
                  <!-- Version Mobile - Boutons empilés verticalement -->
                  <div class="d-block d-md-none">
                    <div class="d-flex flex-column">
                      <slot name="primaryActions"></slot>
                    </div>
                  </div>
                  <!-- Version Desktop - Boutons alignés horizontalement -->
                  <div class="d-none d-md-block">
                    <div class="d-flex justify-content-end">
                      <slot name="primaryActions"></slot>
                    </div>
                  </div>
                </b-col>
              </b-row>
            </header>
            
            <!-- Navigation Tabs -->
            <div v-if="$slots.navigationTabs" class="bg-white border border-top-0 border-bottom py-3 mb-0 mx-n4">
              <div class="px-4">
                <slot name="navigationTabs"></slot>
              </div>
            </div>
            
            <!-- Secondary Actions avec séparation visuelle marquée et Tailwind -->
            <div v-if="$slots.secondaryActions || showFilter || showRefresh || showExtract" class="bg-light border border-top-0 border-bottom py-3 mb-0 mx-n4 shadow-sm">
              <div class="px-4">
                <!-- Conteneur flex responsive pour les boutons UNIQUEMENT -->
                <div class="secondary-actions-container" style="display: flex !important; flex-wrap: wrap !important; gap: 0.5rem !important; width: 100% !important;">
                  <!-- Boutons standards gérés par PageOutline -->
                  <app-button v-if="showFilter"
                    :text="filterExpanded ? $t('filter.hide_fltr') : $t('filter.fltr')"
                    :icon="filterExpanded ? 'fa-light fa-minus' : 'fa-light fa-plus'"
                    variant="light"
                    :responsive-layout="true"
                    :aria-expanded="filterExpanded"
                    @click="$emit('toggle-filter')"
                  />
                  <app-button v-if="showRefresh"
                    :text="$t('common.rfrsh')"
                    icon="fa-light fa-rotate-right"
                    variant="light"
                    :responsive-layout="true"
                    :disabled="refreshDisabled"
                    :aria-label="$t('common.rfrsh')"
                    @click="$emit('refresh')"
                  />
                  <app-button v-if="showExtract"
                    :text="extractText || $t('common.extract')"
                    icon="fa-light fa-download"
                    variant="light"
                    :responsive-layout="true"
                    :disabled="extractDisabled"
                    :aria-label="extractText || $t('common.extract')"
                    @click="$emit('extract')"
                  />
                  <!-- Slot pour les boutons additionnels -->
                  <slot name="secondaryActions"></slot>
                </div>
              </div>
              
              <!-- Contenu des filtres COMPLÈTEMENT SÉPARÉ des boutons -->
              <div v-if="filterExpanded && $slots.filterContent" 
                   class="filter-content-section tw-w-full tw-mt-4 tw-pt-4 tw-border-t tw-border-gray-300 tw-block tw-clear-both"
                   style="display: block !important; clear: both !important;">
                <div class="px-4">
                  <slot name="filterContent"></slot>
                </div>
              </div>
            </div>
            
            <!-- Contenu principal avec espacement -->
            <div class="bg-white border-left border-right border-bottom mx-n4 px-4 py-4">
              <slot name="pageContent"></slot>
            </div>
            
            <!-- Actions du bas avec séparation claire -->
            <div v-if="$slots.bottomActions" class="bg-light border border-top-0 mt-0 mx-n4 px-4 py-4" style="margin-bottom: -25px;">
              <div class="d-flex justify-content-end flex-wrap">
                <slot name="bottomActions"></slot>
              </div>
            </div>
          </main>
          <slot name="underPanel"></slot>
        </b-col>
      </b-row>
      <slot name="footerButtons"></slot>
      <!-- <div class="toolbarPageBottomBlank"></div> -->
      <footer class="pb-10px mb-4" aria-label="Informations de bas de page principale">
        <b-row>
          <b-col :md="colWidth" :offset-md="(12 - colWidth)/2">
            <!-- Version mobile et tablette (< 1100px) : liens empilés -->
            <div class="text-center footer-stacked">
              <div class="d-inline-flex align-items-center justify-content-center flex-wrap mb-2">
                <img class="logoStreammind" alt="Streammind" :src="logoStreammind" />
                <span class="ml-1">{{ $t('common.copyright') }}</span>&nbsp;
                <span>{{ version }}</span>
              </div>
              <div class="d-flex justify-content-center flex-wrap">
                <a
                  href="/sitemap"
                  target="_blank"
                  rel="noopener noreferrer"
                  class="text-decoration-underline text-muted d-inline-block mx-2"
                  style="font-size: 11px; white-space: nowrap;"
                >
                  {{ $t('footer.sitemap') }}
                </a>
                <a
                  href="/accessibilite"
                  target="_blank"
                  rel="noopener noreferrer"
                  class="text-decoration-underline text-muted d-inline-block mx-2"
                  style="font-size: 11px; white-space: nowrap;"
                >
                  {{ accessibilityText }}
                </a>
              </div>
            </div>
            
            <!-- Version desktop large (>= 1100px) : liens côte à côte -->
            <div class="position-relative text-center footer-inline" style="min-height: 1.5rem;">
              <!-- Lien Plan du site -->
              <div
                class="text-left"
                style="position: absolute; left: 10px; top: 50%; transform: translateY(-50%);"
              >
                <a
                  href="/sitemap"
                  target="_blank"
                  rel="noopener noreferrer"
                  class="text-decoration-underline d-inline-block"
                  style="font-size: 12px; white-space: nowrap; color: #000;"
                >
                  {{ $t('footer.sitemap') }}
                </a>
              </div>
              <!-- Bloc centré -->
              <div class="d-inline-flex align-items-center justify-content-center flex-wrap">
                <img class="logoStreammind" alt="Streammind" :src="logoStreammind" />
                <span class="ml-1">{{ $t('common.copyright') }}</span>&nbsp;
                <span>{{ version }}</span>
              </div>
              <!-- Lien accessibilité  -->
              <div
                class="text-right"
                style="position: absolute; right: 10px; top: 50%; transform: translateY(-50%);"
              >
                <a
                  href="/accessibilite"
                  target="_blank"
                  rel="noopener noreferrer"
                  class="text-decoration-underline d-inline-block"
                  style="font-size: 12px; white-space: nowrap; color: #000;"
                >
                  {{ accessibilityText }}
                </a>
              </div>
            </div>
          </b-col>
        </b-row>
      </footer>
    </b-container>
  </f7-page>
</template>

<script>
import StreammindImage from './../../assets/static/images/streammind-text-seul.png'
import backButton from '@/components/common/backButton.vue'
import AppButton from '@/components/common/AppButton.vue'
import bgImg from '../../assets/static/images/header/essai-lg.jpg'

export default {
  name: 'PageOutline',
  components: {
    'back-button': backButton,
    'app-button': AppButton
  },
  props: {
    color: {
      default: 'var(--actionTextColor)'
    },
    colWidth: {
      default: '10'
    },
    icon: {
      default: ''
    },
    iconF7: {
      default: ''
    },
    iconFA: {
      default: ''
    },
    mandatoryIndication: {
      type: Boolean,
      default: false
    },
    noReduce: {
      type: Boolean,
      default: false
    },
    noReturn: {
      type: Boolean,
      default: false
    },
    pageClass: {
      type: String,
      default: ''
    },
    returnUrl: {
      default: 'none'
    },
    title: {
      default: 'Title'
    },
    accessibilityCompliant: {
      type: Boolean,
      default: true
    },
    mainContentId: {
      type: String,
      default: 'main-content'
    },
    // Props pour les boutons secondaires standards
    showFilter: {
      type: Boolean,
      default: false
    },
    showRefresh: {
      type: Boolean,
      default: false
    },
    showExtract: {
      type: Boolean,
      default: false
    },
    filterExpanded: {
      type: Boolean,
      default: false
    },
    refreshDisabled: {
      type: Boolean,
      default: false
    },
    extractDisabled: {
      type: Boolean,
      default: false
    },
    extractText: {
      type: String,
      default: null
    }
  },
  computed: {
    isSmartphoneOS () {
      return this.$f7.device.os === 'android' || this.$f7.device.os === 'ios'
    },
    accessibilityText() {
      // Utiliser la propriété si elle est définie, sinon vérifier le nom du composant parent
      if (this.accessibilityCompliant) {
        return this.$t('footer.accessibility_notice_compliant')
      }
      
      // Fallback: vérifier le nom du composant parent
      const parentComponent = this.$parent?.$options?.name || ''
      const accessibleComponents = ['SitemapPage', 'AccessibilitePage', 'Homepage']
      const isAccessible = accessibleComponents.includes(parentComponent)
      
      return isAccessible 
        ? this.$t('footer.accessibility_notice_compliant') 
        : this.$t('footer.accessibility_notice')
    }
  },
  data () {
    return {
      logoStreammind: StreammindImage,
      bgImage: 'background-image: linear-gradient(rgba(255,255,255,0),rgba(255,255,255,1)),url('+ bgImg +');background-position:bottom;background-size:cover;top:84px;height:370px;',
      customPageClass: '',
      version: '',
      baseTitle: 'DealPrudence'
    }
  },
  created () {
    this.customPageClass = this.pageClass
    this.$bus.$emit('change-mobile-header', {
      backLink: true,
      navbarInnerStyle: 'justify-content:start;',
      navTitle: this.title,
      returnUrl: this.returnUrl
    })
    if (this.$engine.firstOn().versionAPI) {
      this.version = 'Version ' + this.$engine.firstOn().versionAPI
    }
    // Mettre à jour le titre du document
    this.updateDocumentTitle()
  },
  methods: {
    updateDocumentTitle() {
      if (this.title && this.title !== 'Title') {
        document.title = `${this.title} - ${this.baseTitle}`
      }
    }
  },
  watch: {
    title(newTitle) {
      this.updateDocumentTitle()
    }
  }
}
</script>

<style scoped>
/* Conteneur pour les actions secondaires */
.secondary-actions-container {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  width: 100%;
}

@media (min-width: 768px) {
  .secondary-actions-container {
    flex-direction: row;
  }
  
  /* Cibler les divs wrapper créés par AppButton avec responsiveLayout */
  .secondary-actions-container > div {
    flex: 1;
  }
  
  /* S'assurer que les boutons dans les wrappers prennent toute la largeur */
  .secondary-actions-container button {
    width: 100%;
  }
}

/* Breakpoint personnalisé à 1100px */
@media (max-width: 1099px) {
  .footer-inline {
    display: none !important;
  }
  .footer-stacked {
    display: block !important;
  }
}

@media (min-width: 1100px) {
  .footer-inline {
    display: block !important;
  }
  .footer-stacked {
    display: none !important;
  }
}

/* Styles pour le header avec actions */
.panel-heading {
  padding-right: 1rem;
  padding-left: 1rem;
}



/* Force le contenu des filtres à s'afficher correctement en dessous */
::v-deep .filter-content-wrapper {
  width: 100% !important;
  display: block !important;
  clear: both !important;
  margin-top: 1rem !important;
  padding-top: 1rem !important;
  border-top: 1px solid #d1d5db !important;
  flex-basis: 100% !important;
  order: 999 !important;
}

/* Force les boutons à ne pas prendre toute la place */
.secondary-actions-container {
  display: flex !important;
  flex-wrap: wrap !important;
}

.secondary-actions-container > * {
  flex-shrink: 0 !important;
}

/* Ajustements pour mobile */
@media (max-width: 767px) {
  .panel-heading .row {
    align-items: flex-start !important;
  }
  
  /* Boutons pleine largeur sur mobile dans primaryActions */
  .panel-heading .d-flex.flex-column ::v-deep button {
    width: 100% !important;
    margin-bottom: 0.5rem;
  }
  
  .panel-heading .d-flex.flex-column ::v-deep button:last-child {
    margin-bottom: 0;
  }
}

/* Style desktop pour primaryActions */
@media (min-width: 768px) {
  .panel-heading .d-flex.justify-content-end ::v-deep button {
    margin-left: 0.5rem;
  }
  
  .panel-heading .d-flex.justify-content-end ::v-deep button:first-child {
    margin-left: 0;
  }
}

</style>
